import type { RefObject } from "react";

export function getFieldLabel(ref: RefObject<HTMLElement | null>): HTMLLabelElement | null {
  if (!ref.current) {
    return null;
  }

  const refElementIsFormField = ref.current.dataset.formField;
  if (!refElementIsFormField) {
    throw new Error("Provided element is not FormField components");
  }

  const htmlLabel = ref.current.querySelector("label");

  if (!(htmlLabel instanceof HTMLLabelElement) || htmlLabel.children.length === 0) {
    throw new Error("FormField component do not have <label> with at least one child");
  }

  return htmlLabel;
}
